import { AbstractControl } from '@angular/forms';
import { isHexCode } from '@array-app/shared/utils';

export function hexCodeValidator(control: AbstractControl) {
	if (!isHexCode(control.value)) {
		return { invalidColor: true };
	}
	return null;
}
